module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ai-image-container"
  }, [_c('div', {
    staticClass: "type-tabs"
  }, _vm._l((_vm.typeTabs), function(tab) {
    return _c('div', {
      key: tab.type,
      class: ['tab-item', {
        'active': _vm.activeType === tab.type
      }],
      on: {
        "click": function($event) {
          return _vm.handleTypeChange(tab.type)
        }
      }
    }, [_vm._v("\n      " + _vm._s(tab.name) + "\n    ")])
  }), 0), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    ref: "workflowList",
    staticClass: "workflow-list",
    on: {
      "scroll": _vm.handleScroll
    }
  }, _vm._l((_vm.workflowList), function(workflow) {
    return _c('div', {
      key: workflow.id,
      staticClass: "workflow-item",
      on: {
        "click": function($event) {
          return _vm.handleWorkflowClick(workflow)
        }
      }
    }, [_c('div', {
      staticClass: "workflow-preview",
      style: ({
        backgroundImage: workflow.preview ? ("url(" + (workflow.preview) + ")") : 'none'
      })
    }, [(!workflow.preview) ? _c('div', {
      staticClass: "no-preview"
    }, [_c('img', {
      attrs: {
        "src": require("./AiImage-Item.png"),
        "alt": "默认预览图"
      }
    })]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "workflow-overlay"
    }, [_c('div', {
      staticClass: "workflow-info-default"
    }, [_c('h3', {
      staticClass: "workflow-title"
    }, [_vm._v(_vm._s(workflow.name))]), _vm._v(" "), _c('div', {
      staticClass: "workflow-price"
    }, [_c('span', {
      staticClass: "price-label"
    }, [_vm._v("消耗点数:")]), _vm._v(" "), _c('span', {
      staticClass: "price-value"
    }, [_vm._v(_vm._s(workflow.price || 0))])])]), _vm._v(" "), _c('div', {
      staticClass: "workflow-info-hover"
    }, [_c('h3', {
      staticClass: "workflow-title"
    }, [_vm._v(_vm._s(workflow.name))]), _vm._v(" "), _c('p', {
      staticClass: "workflow-description"
    }, [_vm._v(_vm._s(workflow.description || '暂无描述'))])])])])])
  }), 0), _vm._v(" "), (_vm.workflowList.length === 0 && !_vm.loading) ? _c('div', {
    staticClass: "empty-state"
  }, [_c('i', {
    staticClass: "el-icon-picture-outline"
  }), _vm._v(" "), _c('p', [_vm._v("暂无可用的AI工作流")])]) : _vm._e(), _vm._v(" "), (_vm.loadingMore) ? _c('div', {
    staticClass: "loading-more"
  }, [_c('i', {
    staticClass: "el-icon-loading"
  }), _vm._v(" "), _c('span', [_vm._v("加载中...")])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1ad7ee76","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AiImage/AiImage.vue
// module id = 375
// module chunks = 0